import { Component } from '@theme/component';
import { SlideshowSelectEvent } from '@theme/events';

/**
 * ProductListTabs component
 * @typedef {object} Refs
 * @property {HTMLButtonElement[]} tabs
 *
 * @extends {Component<Refs>}
 */
export class ProductListTabs extends Component {

  connectedCallback() {
    super.connectedCallback();

    this.refs.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.#onTabClick(tab));
    });

    this.#showCollection(this.refs.tabs[0]?.getAttribute('data-collection-handle') || null);
  }

  /**
   * @param {HTMLButtonElement} tab
   */
  #onTabClick(tab) {
    this.refs.tabs.forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');
    this.#showCollection(tab.getAttribute('data-collection-handle'));
  }

  /**
   * @param {string | null} handle
   */
  #showCollection(handle) {
    if (!this.parentNode) return;

    this.parentNode.querySelectorAll('product-card[data-collection-handle]').forEach(card => {
      const slideElement = card.closest('slideshow-slide');
      if (slideElement && slideElement instanceof HTMLElement) {
        const shouldShow = card.getAttribute('data-collection-handle') === handle;
        slideElement.style.display = shouldShow ? '' : 'none';
        slideElement.style.visibility = shouldShow ? '' : 'hidden';
      }

    });

    this.#refreshCardGallerySlideshows();

    const productCarousel = this.parentNode.querySelector('slideshow-component[ref="resourceListCarousel"]');
    if (!productCarousel) return;

    const selectFirstVisibleSlide = () => {
      queueMicrotask(() => {
        // After changing visibility, select the first visible slide (index 0 in filtered array)
        // @ts-ignore - select is a custom method on slideshow-component
        productCarousel.select?.(0, null, {animate: false});
      });
    };

    if (customElements.get('slideshow-component')) {
      selectFirstVisibleSlide();
    } else {
      customElements.whenDefined('slideshow-component').then(selectFirstVisibleSlide);
    }
  }

  #refreshCardGallerySlideshows() {
    if (!this.parentNode) return;

    const refresh = () => {
      this.parentNode.querySelectorAll('product-card[data-collection-handle]').forEach((card) => {
        const cardGallerySlideshow =
          card.querySelector('[ref="cardGallery"] slideshow-component[ref="slideshow"]') ||
          card.querySelector('[ref="cardGallery"] > slideshow-component') ||
          card.querySelector('[ref="cardGalleryLink"] > slideshow-component');

        // @ts-ignore - updateVisibleSlides is a custom method on slideshow-component
        cardGallerySlideshow?.updateVisibleSlides?.();
      });
    };

    if (customElements.get('slideshow-component')) {
      refresh();
    } else {
      customElements.whenDefined('slideshow-component').then(refresh);
    }
  }
}

if (!customElements.get('product-list-tabs')) {
  customElements.define('product-list-tabs', ProductListTabs);
}